import { BRAND_LOGO, BRAND_NAME } from "../../constants/Branding";

const logoSrc = sessionStorage.getItem("brandLogo") || BRAND_LOGO;

const Maintenance = () => {
  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        boxSizing: "border-box",
        backgroundColor: "#071123",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "#F2F6FF",
        textAlign: "center",
        padding: "24px",
        margin: 0,
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          maxWidth: 720,
          width: "100%",
        }}
      >
        {logoSrc ? (
          <img
            src={logoSrc}
            alt={BRAND_NAME || "brand"}
            style={{
              display: "block",
              maxHeight: 80,
              maxWidth: 280,
              width: "auto",
              height: "auto",
              objectFit: "contain",
              margin: "0 auto 24px",
            }}
          />
        ) : null}
        <h1 style={{ fontSize: "32px", fontWeight: 700, margin: 0 }}>
          The site is under maintenance
        </h1>
        <p
          style={{
            marginTop: "16px",
            fontSize: "16px",
            opacity: 0.8,
            maxWidth: "640px",
            lineHeight: 1.5,
          }}
        >
          Our website is currently undergoing maintenance to improve your
          experience. We appreciate your patience and will be back online
          shortly.
        </p>
      </div>
    </div>
  );
};

export default Maintenance;
